import styled from 'styled-components';
import { COLORS } from 'modules/core/theme/colors';
import { Dropdown, InputGroup } from 'react-bootstrap';

import { DROPDOWN_ARROW_STYLES } from '../styles';

const OVERRIDER_DROPDOWN_SELECTORS = `
  &,
  &:hover,
  &:focus,
  &:checked,
  &.btn-primary:not(:disabled):not(.disabled):active,
  .show > &.btn-primary.dropdown-toggle
`;

const getBorderColor = ({ $isInvalid, $isWarning }: { $isInvalid?: boolean; $isWarning?: boolean }) => {
  if ($isInvalid) return COLORS.RED_3;

  return $isWarning ? COLORS.ORANGE_5 : COLORS.GREY_32;
};

export const InputGroupUI = styled(InputGroup)<{
  $isInvalid?: boolean;
  $isWarning?: boolean;
  $isPlaceholder?: boolean;
  $isAnimated?: boolean;
  $autoWidth?: number;
}>`
  ${({ $autoWidth }) => $autoWidth && `width: ${$autoWidth}px; max-width: ${$autoWidth}px;`}
  .btn.disabled,
  .btn:disabled,
  fieldset:disabled .btn {
    background-color: ${COLORS.GREY_31};
    opacity: 1;
    border: 1px solid ${COLORS.GREY_32} !important;
    border-color: ${({ $isAnimated }) => $isAnimated && COLORS.BLUE_12};
  }
  .btn { ${OVERRIDER_DROPDOWN_SELECTORS} {
    background-color: ${({ theme: { colors } }) => colors.white};
    border: 1px solid ${getBorderColor} !important;
    color: ${({ theme: { colors }, $isPlaceholder }) => ($isPlaceholder ? COLORS.GREY_24 : colors.black)};
    box-shadow: none;
    ${({ $isPlaceholder }) => !$isPlaceholder && `font-weight: bold;`};
    border-color: ${({ $isAnimated }) => $isAnimated && COLORS.BLUE_12};
    box-shadow: ${({ $isAnimated }) => $isAnimated && `0px 0px 3px 3px ${COLORS.BLUE_12}a1`};
    border-radius: 0.375rem !important;
    ${({ $autoWidth }) => $autoWidth && `width: ${$autoWidth}px;`}
  }
`;

export const RacDropdown = styled(Dropdown)`
  btn.disabled,
  .btn:disabled,
  fieldset:disabled .btn {
    color: ${COLORS.GREY_24};
    background-color: ${COLORS.GREY_31};
    opacity: 1;
    border: 1px solid ${COLORS.GREY_32};
  }
`;

export const Menu = styled(Dropdown.Menu)`
  width: 100%;
  padding: 0;
  max-height: 20vh;
  overflow: auto;
  min-width: 0;

  a:hover {
    background-color: #f0f0f0;
    color: black;
  }
`;

export const MenuItem = styled(Dropdown.Item)`
  font-size: ${({ theme: { fontSize } }) => fontSize.normal};
  text-align: center;
  padding: 5px;
  margin: 2px 0;
  position: relative;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const DropdownToggle = styled(Dropdown.Toggle)`
  width: 100%;
  height: 25px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${({ theme: { fontSize } }) => fontSize.normal};
  padding-top: 0;
  padding-bottom: 0;

  &::after {
    display: ${({ $isAnimated }) => ($isAnimated ? 'none' : 'inline-block')};
    ${DROPDOWN_ARROW_STYLES}
  }
`;

export const DefaultToggle = styled(DropdownToggle)`
  display: block;
  width: 100%;
  padding-left: 5px;
  padding-right: 5px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
  ${({ $isAnimated }) => $isAnimated && `color: transparent !important;`};
  transition: color 0.5s ease;
`;
